import { render } from "./VendorHeader.vue?vue&type=template&id=a858d9a6"
import script from "./VendorHeader.vue?vue&type=script&lang=js"
export * from "./VendorHeader.vue?vue&type=script&lang=js"

import "../styles/VendorHeader.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__